__webpack_require__.p = "/bulk-actions-controller/referrals-hub/";